import React, { Fragment, useState } from "react";
import Image from "next/image";
import Container from "@mui/material/Container";
import { Box, Typography, Popper, Grid, Paper, Stack } from "@mui/material";
import Link from "next/link";
import Button from "@mui/material/Button";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import SectionOneImage from "../public/images/new-backstage/section1.png";
import SectionThreeImage from "../public/images/new-backstage/section3.png";
import SectionFiveImage from "../public/images/new-backstage/section5.png";
import SectionSixOneImage from "../public/images/new-backstage/square.png";
import SectionSixTwoImage from "../public/images/new-backstage/circle.png";
import SectionSixThreeImage from "../public/images/new-backstage/rectangle.png";
import SectionSixFourImage from "../public/images/new-backstage/Triangle.png";
import SectionEightImage from "../public/images/new-backstage/sec8.png";
import SectionTenImage from "../public/images/new-backstage/sectionTen.png";
import Section10Arrow from "../public/images/new-backstage/arrow.png";
import ReasonOneImage from "../public/images/new-backstage/res1.png";
import ReasonTwoImage from "../public/images/new-backstage/res2.png";
import ReasonThreeImage from "../public/images/new-backstage/res3.png";
import ReasonFourImage from "../public/images/new-backstage/res4.png";
import talkToImage from "../public/images/new-backstage/talkTo.png";

import SectionTwoOneImage from "../public/images/new-backstage/section21.png";
import SectionTwoTwoImage from "../public/images/new-backstage/section22.png";
import SectionTwoThreeImage from "../public/images/new-backstage/section23.png";
import SectionWhatFreeImage from "../public/images/new-backstage/what_free.png";
import FaceBookIcon from '../public/images/new-backstage/facebook.png'
import InstagramIcon from '../public/images/new-backstage/insta2.png'
import WhatsAppIcon from '../public/images/new-backstage/whatsapp2.png'


// import OGImage from "../images/new-backstage/og.jpg";


// import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/styles.css";
import darkTheme from "../src/themeNew";
import Drawer from "@mui/material/Drawer";

import { Navigation, Pagination, Autoplay, FreeMode, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import BakstageForm from "../components/backstage/Form";
import { Close } from "@mui/icons-material";
import Head from "next/head";

import { useRouter } from 'next/router';



const font = {
  fontFamily: "DM Sans, sans-serif",
};

const backstageContainer = {
  "& h1": {
    fontSize: 60,
    background:'#121212',
    color: darkTheme.palette.common.white,
    fontWeight: 700,
    marginBottom: darkTheme.spacing(1),
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 25,
      fontWeight: 500,
    },
  },
};


const buttonStyle = {
  background: '#61FC6E',
  color:'#000',
  fontWeight: 500,
  textTransform: "uppercase",
  borderRadius: 50,
  transition: 'transform 0.15s cubic-bezier(0, 0.2, 0.5, 3) 0s !important',
  '&:hover': {
     background: '#61FC6E',
    color:'#000',
    transform: 'scale(1.04) !important'
  },
  [darkTheme.breakpoints.down("md")]: {
    fontSize: "12px !important",
    fontWeight: 500,
  },
};

const ticketsModal = {
  background: darkTheme.palette.background.default,
  paddingTop: 0,
  h3: {
    fontSize: 14,
    fontWeight: 100,
    color: darkTheme.palette.primary.dates,
    textTransform: "capitalize",
    marginTop: darkTheme.spacing(2),
    marginTop: darkTheme.spacing(1),
  },
};

const muiDrawer = {
  "& .MuiDrawer-paper": {
    background: darkTheme.palette.background.default,
    borderLeft: `1px solid ${darkTheme.palette.background.ticket}`,
    maxWidth: "33.33%",
    width: "33.33%",
    p: 4,
    paddingBottom: darkTheme.spacing(6),
    // borderRadius: '20px 0 0 0',
    [darkTheme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "100%",
      borderLeft: "none",
    },
  },
};

const section1 = {
  background: "#121212",
  paddingTop: darkTheme.spacing(13),
  paddingBottom: darkTheme.spacing(10),
  [darkTheme.breakpoints.down("md")]: {
    // paddingTop: darkTheme.spacing(12),
    paddingBottom: darkTheme.spacing(2),
  },
  "& h2": {
    fontSize: 40,
    color: darkTheme.palette.common.white,
    fontWeight: 700,
    marginBottom: darkTheme.spacing(1),
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 25,
      fontWeight: 400,
    },
  },
  "& h6": {
    fontSize: 16,
    color: darkTheme.palette.primary.location,
    fontWeight: 300,
    marginTop: darkTheme.spacing(1),
    marginBottom: darkTheme.spacing(1),
  },
};

const section2 = {
  background: "#0c0c0c",
  paddingTop: darkTheme.spacing(20),
  paddingBottom: darkTheme.spacing(10),
  [darkTheme.breakpoints.down("md")]: {
    paddingTop: darkTheme.spacing(6),
    paddingBottom: darkTheme.spacing(2),
  },
  "& h2": {
    fontSize: 40,
    color: darkTheme.palette.common.white,
    fontWeight: 700,
    marginBottom: darkTheme.spacing(5),
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 25,
      fontWeight: 400,      
    },
  },
  "& h6": {
    fontSize: "12px !important",
    color: '#AEAEAE',
    fontWeight: 100,
    [darkTheme.breakpoints.down("md")]: {      
      marginTop: darkTheme.spacing(3),
      textAlign:'center'
    },
  },
};

const section3 = {
  background: "#121212",
  paddingTop: darkTheme.spacing(10),
  paddingBottom: darkTheme.spacing(10),
  [darkTheme.breakpoints.down("md")]: {
    paddingTop: darkTheme.spacing(6),
    paddingBottom: darkTheme.spacing(2),
    px:2,
  },
  "& h2": {
    fontSize: 40,
    color: darkTheme.palette.common.white,
    fontWeight: 700,
    marginBottom: darkTheme.spacing(1),
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 25,
      fontWeight: 400,
      
    },
  },
  "& h6": {
    fontSize: 16,
    color: darkTheme.palette.primary.location,
    fontWeight: 300,
    marginTop: darkTheme.spacing(1),
    marginBottom: darkTheme.spacing(1),
  },
};

const section4 = {
  background: "#0c0c0c",
  paddingTop: darkTheme.spacing(10),
  paddingBottom: darkTheme.spacing(10),
  [darkTheme.breakpoints.down("md")]: {
    paddingTop: darkTheme.spacing(6),
    paddingBottom: darkTheme.spacing(2),
  },
  "& h3": {
    fontSize: 40,
    color: darkTheme.palette.common.white,
    fontWeight: 700,
    marginBottom: darkTheme.spacing(5),
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 25,
      fontWeight: 400,
    },
  },
  "& .box": {
    px: darkTheme.spacing(2),
    py: darkTheme.spacing(3),
    borderRadius: 5,
    background: "#121212",
    minHeight: 375,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    textAlign: "flex-start",
    cursor: "pointer",
    [darkTheme.breakpoints.down("md")]: {
      flexDirection: "column",
      justifyContent: "space-between",
      textAlign: "flex-start",
    },
    "& h4": {
      fontSize: 28,
      color: "#ffffff70",
      fontWeight: 700,
      marginBottom: darkTheme.spacing(1),
      px: darkTheme.spacing(2),
      width: `90%`,
    },
    "& h2": {
      fontSize: 75,
      color: darkTheme.palette.common.white,
      fontWeight: 700,
      writingMode: `tb-rl`,
      transform: `rotate(-180deg)`,
      display: "flex",
      flexDirection: "column",
      alignSelf: "flex-start",
      flexGrow: 1,
      [darkTheme.breakpoints.down("md")]: {
        fontSize: 50,
      },
    },
  },
  "& .boxActive": {
    padding: darkTheme.spacing(4),
    borderRadius: 5,
    background: "#61fc6e",
    minHeight: 375,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    textAlign: "flex-start",
    cursor: "pointer",
    transition: "0.10s",
    [darkTheme.breakpoints.down("md")]: {
      flexDirection: "column",
      justifyContent: "space-between",
      textAlign: "start",
      padding: darkTheme.spacing(3),
      minHeight: 275,
    },
    "& h4": {
      fontSize: 30,
      color: `#00000070`,
      fontWeight: 700,
      marginBottom: darkTheme.spacing(1),
      px: darkTheme.spacing(3),
      width: `80%`,
      [darkTheme.breakpoints.down("md")]: {
        width: `100%`,
        px: darkTheme.spacing(1),
      },
    },
    "& h5": {
      fontSize: 16,
      color: "#000",
      fontWeight: 100,
      marginLeft: darkTheme.spacing(1),
    },
    "& h2": {
      fontSize: 75,
      color: darkTheme.palette.common.black,
      fontWeight: 700,
      writingMode: `tb-rl`,
      transform: `rotate(-180deg)`,
      [darkTheme.breakpoints.down("md")]: {
        fontSize: 75,
      },
    },
  },
};

const section5 = {
  background: "#1f1f1f",
  paddingTop: darkTheme.spacing(10),
  paddingBottom: darkTheme.spacing(10),
  [darkTheme.breakpoints.down("md")]: {
    paddingTop: darkTheme.spacing(6),
    paddingBottom: darkTheme.spacing(2),
  },
  "& h2": {
    fontSize: 40,
    color: darkTheme.palette.common.white,
    fontWeight: 700,
    marginBottom: darkTheme.spacing(1),
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 25,
      fontWeight: 400,
    },
  },
  "& h6": {
    fontSize: 16,
    color: darkTheme.palette.primary.location,
    fontWeight: 300,
    marginTop: darkTheme.spacing(1),
    marginBottom: darkTheme.spacing(1),
  },
};

const section6 = {
  background: "#0c0c0c",
  padding: darkTheme.spacing(10),
  [darkTheme.breakpoints.down("md")]: {
    paddingTop: darkTheme.spacing(6),
    paddingBottom: darkTheme.spacing(2),
    padding: darkTheme.spacing(3),
  },
  "& h2": {
    fontSize: 40,
    color: darkTheme.palette.common.white,
    fontWeight: 700,
    marginBottom: darkTheme.spacing(1),
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 25,
      fontWeight: 400,
    },
  },
  "& h5": {
    fontSize: 20,
    color: '#fff',
    fontWeight: 300,
    // marginTop: darkTheme.spacing(1),
    // marginBottom: darkTheme.spacing(1),
    display:'flex',
    alignSelf:'center'
  },
  "& h6": {
    fontSize: 16,
    color: darkTheme.palette.primary.location,
    fontWeight: 300,
    marginTop: darkTheme.spacing(1),
    marginBottom: darkTheme.spacing(1),    
  },
};

const section7 = {
  background: "#1f1f1f",
  paddingTop: darkTheme.spacing(10),
  paddingBottom: darkTheme.spacing(10),
  [darkTheme.breakpoints.down("md")]: {
    paddingTop: darkTheme.spacing(6),
    paddingBottom: darkTheme.spacing(2),
  },
  "& h2": {
    fontSize: 40,
    color: darkTheme.palette.common.white,
    fontWeight: 700,
    marginBottom: darkTheme.spacing(3),
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 25,
      fontWeight: 400,
    },
  },
  "& h4": {
    fontSize: 25,
    color: darkTheme.palette.common.white,
    fontWeight: 500,
    marginTop: darkTheme.spacing(3),
    marginBottom: darkTheme.spacing(1),
  },
  "& h6": {
    fontSize: 16,
    color: "#AEAEAE !important",
    fontWeight: 100,
    marginBottom: darkTheme.spacing(3),
    letterSpacing: 1,
  },
};

const section8 = {
  background: "#1f1f1f",
  // paddingTop: darkTheme.spacing(10),
  paddingBottom: darkTheme.spacing(10),
  [darkTheme.breakpoints.down("md")]: {
    paddingTop: darkTheme.spacing(6),
    paddingBottom: darkTheme.spacing(2),
  },
  "& h2": {
    fontSize: 40,
    color: darkTheme.palette.common.white,
    fontWeight: 700,
    marginBottom: darkTheme.spacing(3),
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 25,
      fontWeight: 400,
      marginBottom: darkTheme.spacing(1),
    },
    [darkTheme.breakpoints.down("sm")]: {
      fontSize: 20,
      fontWeight: 400,
      marginBottom: darkTheme.spacing(1),
    },
  },
  "& h4": {
    fontSize: 25,
    color: darkTheme.palette.common.white,
    fontWeight: 500,
    marginTop: darkTheme.spacing(3),
    marginBottom: darkTheme.spacing(1),
  },
  "& h6": {
    fontSize: 16,
    color: "#AEAEAE !important",
    fontWeight: 100,
    marginBottom: darkTheme.spacing(3),
    letterSpacing: 1,
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 14,
      fontWeight: 200,
      letterSpacing: 0,
      marginBottom: darkTheme.spacing(0),
    },
  },
};

const section9 = {
  background: "#0c0c0c",
  paddingTop: darkTheme.spacing(10),
  paddingBottom: darkTheme.spacing(10),
  [darkTheme.breakpoints.down("md")]: {
    paddingTop: darkTheme.spacing(6),
    paddingBottom: darkTheme.spacing(2),
  },
  "& h2": {
    fontSize: 40,
    color: darkTheme.palette.common.white,
    fontWeight: 700,
    marginBottom: darkTheme.spacing(3),
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 25,
      fontWeight: 400,
    },
  },
  "& h6": {
    fontSize: 16,
    color: "#AEAEAE !important",
    fontWeight: 100,
    marginBottom: darkTheme.spacing(3),
    letterSpacing: 1,
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 14,
      fontWeight: 200,
      letterSpacing: 0,
      marginBottom: darkTheme.spacing(0),
    },
  },
};

const accordion = {
  boxShadow: darkTheme.shadows[0],
  // marginTop: darkTheme.spacing(2),
  // marginBottom: darkTheme.spacing(2),
  borderRadius: `0 !important`,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  // [darkTheme.breakpoints.down("md")]: {
  //   marginTop: darkTheme.spacing(1),
  //   marginBottom: darkTheme.spacing(1),
  // },

  // background: darkTheme.palette.background.default,
  "& h4": {
    fontSize: 18,
    fontWeight: 100,
    color: `#fff`,
    textTransform: "capitalize",
    marginTop: darkTheme.spacing(2),
    marginBottom: darkTheme.spacing(2),
    [darkTheme.breakpoints.down("md")]: {
      fontSize: `16px !important`,
      fontWeight: 100,
      marginTop: darkTheme.spacing(1),
      marginBottom: darkTheme.spacing(1),
    },
  },
  "& h5": {
    fontSize: 14,
    fontWeight: 100,
    color: `#BABABA`,
    lineHeight:1.9,
    textTransform: "capitalize",
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 14,
      fontWeight: 200,
    },
  },
};

const accordionSummary = {
  boxShadow: darkTheme.shadows[0],
  borderRadius: `0 !important`,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  padding: 0,
};

const IconStyle = {
  padding: "2px",
  background: "#61fe73",
  border: `2px solid #fff`,
  borderRadius: 50,
  color: "#000",
  fontSize: 30,
};

const section10 = {
  backgroundImage: `url('../images/new-backstage/section10.png')`,  
  height: 500,
  width: '100%',
  backgroundPosition: 'center',
  backgroundSize: 'contain',
  objectFit: 'cover',
  backgroundRepeat: 'no-repeat',  
  [darkTheme.breakpoints.down("md")]: {
    backgroundSize: 'cover',
    objectFit: 'cover',
  },
};

const section11 = {
  
  [darkTheme.breakpoints.down("md")]: {
    paddingTop: darkTheme.spacing(6),
    paddingBottom: darkTheme.spacing(2),
  },
  "& h2": {
    fontSize: 40,
    color: darkTheme.palette.common.white,
    fontWeight: 700,
    marginBottom: darkTheme.spacing(3),
    [darkTheme.breakpoints.down("md")]: {
      fontSize: 25,
      fontWeight: 400,
    },
  }
};
// const btn = {
//   background:darktheme
//   fontSize: 16,
//   color: "#AEAEAE !important",
//   fontWeight: 100,
//   marginBottom: darkTheme.spacing(3),
//   letterSpacing: 1,
//   [darkTheme.breakpoints.down("md")]: {
//     fontSize: 14,
//     fontWeight: 200,
//     letterSpacing: 0,
//     marginBottom: darkTheme.spacing(0),
//   },
// };

const hoverAnimation = {
  transition: 'transform 0.15s cubic-bezier(0, 0.2, 0.5, 3) 0s',
  '&:hover': {
    transform: 'scale(1.04)'
  }
}


function Backstage() {
  const [expanded, setExpanded] = useState("panel1");
  const [boxType, setBoxType] = useState("1");
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [placement, setPlacement] = useState();
  const [popType, setPopType] = useState(null);
  const [moreFaqs, setMoreFaqs] = useState(false)

  const Router = useRouter();

  const handleChange = (panel) => (isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const changeBoxType = (type) => (event) => {
    event.preventDefault();
    setBoxType(type);
  };

  const gotoLink = (link) => (event) => {
    // location.href = link;
    event.preventDefault();
    Router.push(link)
  }

  // const handleClick = (newPlacement, type) => (event) => {
  //   setAnchorEl(event.currentTarget);
  //   setOpen((prev) => placement !== newPlacement || !prev);
  //   setPlacement(newPlacement);
  //   setPopType(type);
  // };

  const onCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleChangeHandler = () => {
    // alert('yeah')
    setOpenAlert(true);
  };

  const handleMoreFaqs = () => {
    setMoreFaqs(!moreFaqs)
  }

  return (
    <Fragment>
      <Box>
        <Head>
          <link
            href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap"
            rel="stylesheet"
          />
          <title>
            Whitelabel Web & Mobile Apps for F&B, Nightlife, and Live Event Venues | Clubr Backstage
          </title>
          <meta
            name="description"
            content="Experience the cutting-edge technology of Clubr Backstage, designed for every venue and organizer. With a simple subscription fee, you can build a sustainable brand identity and create a festival-like setup for your day-to-day events. Discover the power of Clubr Backstage today."
          ></meta>
          <meta
            property="og:title"
            content="Whitelabel Web & Mobile Apps for F&B, Nightlife, and Live Event Venues | Clubr Backstage"
          ></meta>
          <meta
            property="og:description"
            content="Experience the cutting-edge technology of Clubr Backstage, designed for every venue and organizer. With a simple subscription fee, you can build a sustainable brand identity and create a festival-like setup for your day-to-day events. Discover the power of Clubr Backstage today."
          ></meta>          
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="Clubr" />
          <meta property="og:url" content="https://backstage.clubr.in/" />
          <meta property="og:image" content={`https://clubr.in/images/new-backstage/og.jpg`} />

          <meta name="twitter:card" content="summary_large_image"></meta>
          <meta name="twitter:site" content="@Clubr14"></meta>
          <meta name="twitter:creator" content="@Clubr14"></meta>
          <meta
            name="twitter:title"
            content="Whitelabel Web & Mobile Apps for F&B, Nightlife, and Live Event Venues | Clubr Backstage"
          ></meta>
          <meta
            name="twitter:description"
            content="Experience the cutting-edge technology of Clubr Backstage, designed for every venue and organizer. With a simple subscription fee, you can build a sustainable brand identity and create a festival-like setup for your day-to-day events. Discover the power of Clubr Backstage today."
          ></meta>         
        </Head>
        <Drawer
          anchor="right"
          open={openAlert}
          onClose={onCloseAlert}
          ModalProps={{
            keepMounted: true,
          }}
          hideBackdrop={true}
          sx={{
            ...muiDrawer,
            backdropFilter: "blur(5px)",
          }}
        >
          <Box sx={ticketsModal}>
            <Stack
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
            >
              <Typography variant="h4" sx={{ mb: 6, ...font }}>
                Please fill up the form
              </Typography>
              <Typography
                variant="h4"
                onClick={onCloseAlert}
                sx={{ cursor: "pointer" }}
              >
                <Close />
              </Typography>
            </Stack>
            {/* <Typography variant='h6' sx={{mb:2, fontSize:12, color:darkTheme.palette.primary.location}}>Lorem ipsum lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum </Typography> */}
            <Typography component="div">
              <BakstageForm />
            </Typography>
          </Box>
        </Drawer>        
        <Typography component="div" sx={backstageContainer}>
          {/* <Box sx={{ pt: 2 }}>
            <Container
              sx={{
                background:'#121212',
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Link href={"https://backstage.clubr.in"} sx={{ flexGrow: "2" }}>
                <a>
                  <Typography component="div" className="desktopMode">
                    <Image
                      src="/images/new-backstage/logo1.png"
                      alt="clubr-logo"
                      width={150}
                      height={42}
                      layout="fixed"
                    />
                  </Typography>
                  <Typography component="div" className="mobileMode">
                    <Image
                      src="/images/new-backstage/logo1.png"
                      alt="clubr-logo"
                      width={100}
                      height={32}
                      layout="fixed"
                    />
                  </Typography>
                </a>
              </Link>
              <Button
                sx={{ ...buttonStyle, ...font, px:5, py:1, fontWeight: 'bold' }}
                type="button"
                // ripple={false}
                onClick={handleChangeHandler}
              >
                Send Enquiry
              </Button>
            </Container>
          </Box> */}
        
          <Box sx={section1}>
            <Container component="div">
              <Grid container spacing={0} alignItems="center">
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{mb:3}} className="mobileMode">
                  <Image
                    src={SectionOneImage}
                    alt="section1"                    
                    layout="responsive"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Typography variant="h2" sx={font}>Most Powerful Platform</Typography>
                  <Typography variant="h2" sx={font}>Ever for Live Events.</Typography>
                  <Typography variant="h6" sx={font}>Clubr 360 platform helps you build Identity, optimize costs, improve operational efficiency, and gain valuable data insights from day-to-day operations.</Typography>
                  <Button
                    sx={{ ...buttonStyle, ...font, px:5, py:1.5, mt:3, fontWeight: 'bold' }}
                    type="button"
                    // ripple={false}
                    onClick={handleChangeHandler}
                  >
                    Send Enquiry
                  </Button>
                </Grid>
                <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>&nbsp;</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="desktopMode">
                  <Image
                    src={SectionOneImage}
                    alt="section1"                    
                    layout="responsive"
                  />
                </Grid>
              </Grid>
            </Container>
          </Box>

          <Box sx={section2}>
            <Container component="div">
              <Swiper
                modules={[Navigation, Pagination, A11y]}
                spaceBetween={1}
                navigation={true}
                autoplay={true}
                loop={true}
                slidesPerView={1} 
                dotsTouchable={true}
                pagination={{
                  clickable: true,
                  paginationType: 'custom',
                  bulletClass: 'my-custom-pagination-item',
                }}
              >
                <SwiperSlide>
                  <Typography component="div" sx={{width:'100%'}}>
                    <Grid container spacing={-5}>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4} alignSelf="flex-start" >
                        <Typography component="div" sx={{
                          ...font,
                          textAlign: {
                            md: 'right', sm: 'center', xs: 'center'
                          },
                          mr: {
                            md: -10, sm: 0, xs: 0
                          },
                          mt: {
                            md: 10, sm: 1, xs: 1
                          },
                        }}>
                          <Typography variant="h2" sx={{ ...font, mb:`0px !important`}}>
                            Build Brand
                          </Typography> 
                          <Typography variant="h2" sx={{ ...font}}>
                            Identity
                          </Typography> 
                        </Typography> 
                      </Grid>
                      <Grid item xs={12} sm={12} md={5} lg={5} xl={5} alignSelf="center">
                        <Image
                          src={SectionTwoOneImage}
                          alt="section1"
                          // width="100"
                          // height="100"
                          layout="responsive"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={3} lg={3} xl={3} alignSelf="flex-end">                  
                        <Typography variant="h6" sx={font}>We empower Venues/Organizers with a Full stack of white-labelled Web & Mobile Apps to deliver a holistic brand experience and build a sustainable brand identity.</Typography>
                      </Grid>
                    </Grid>
                  </Typography>
                </SwiperSlide>
                <SwiperSlide>
                  <Typography component="div" sx={{width:'100%'}}>
                    <Grid container spacing={-5}>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4} alignSelf="flex-start" >
                        <Typography component="div" sx={{
                          ...font,
                          textAlign: {
                            md: 'right', sm: 'center', xs: 'center'
                          },
                          mr: {
                            md: -10, sm: 0, xs: 0
                          },
                          mt: {
                            md: 10, sm: 1, xs: 1
                          },
                        }}>
                          <Typography variant="h2" sx={{ ...font,mb:`0px !important`}}>
                            Emulate Festival
                          </Typography> 
                          <Typography variant="h2" sx={{ ...font}}>
                            Like Setup
                          </Typography> 
                        </Typography>                                          
                      </Grid>
                      <Grid item xs={12} sm={12} md={5} lg={5} xl={5} alignSelf="center">
                        <Image
                          src={SectionTwoTwoImage}
                          alt="section1"
                          // width="100"
                          // height="100"
                          layout="responsive"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={3} lg={3} xl={3} alignSelf="flex-end">                  
                        <Typography variant="h6" sx={font}>Venues/Organizers of any size can leverage our technology and emulate a robust digital infrastructure for their day-to-day events.</Typography>
                      </Grid>
                    </Grid>
                  </Typography>
                </SwiperSlide>
                <SwiperSlide>
                  <Typography component="div" sx={{width:'100%'}}>
                    <Grid container spacing={-5}>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4} alignSelf="flex-start" >
                        <Typography component="div" sx={{
                          ...font,
                          textAlign: {
                            md: 'right', sm: 'center', xs: 'center'
                          },
                          mr: {
                            md: -10, sm: 0, xs: 0
                          },
                          mt: {
                            md: 10, sm: 1, xs: 1
                          },
                        }}>
                          <Typography variant="h2" sx={{ ...font, mb:`0px !important`}}>
                            Amplify your
                          </Typography> 
                          <Typography variant="h2" sx={{ ...font}}>
                            Sales Channels
                          </Typography> 
                        </Typography>                                        
                      </Grid>
                      <Grid item xs={12} sm={12} md={5} lg={5} xl={5} alignSelf="center">
                        <Image
                          src={SectionTwoThreeImage}
                          alt="section1"
                          // width="100"
                          // height="100"
                          layout="responsive"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={3} lg={3} xl={3} alignSelf="flex-end">                  
                        <Typography variant="h6" sx={font}>Unlock new revenue opportunities and expand your sales channels with Clubr. Empower your business to connect with hundreds of promoters and influencers, maximizing your reach and monetizing your operations like never before.</Typography>
                      </Grid>
                    </Grid>
                  </Typography>

                </SwiperSlide>
              </Swiper>
            </Container>
          </Box>
              
          <Box sx={section3}>
            <Typography component="div">
              <Grid container spacing={0} alignItems="center">
                
                <Grid item xs={12} sm={12} md={5} lg={5} xl={5}
                  className="desktopMode"
                >
                  <Image
                    src={SectionThreeImage}
                    alt="section3"
                    // width="100"
                    // height="100"
                    layout="responsive"
                    
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>&nbsp;</Grid>
                <Grid item xs={12} sm={12} md={5} lg={5} xl={5} sx={{mr:{md:5, sm:3, xs:1}}}>
                  <Typography variant="h2" sx={font}>OmniPresent</Typography>
                  <Typography variant="h2" sx={font}>with Clubr</Typography>
                  <Typography variant="h6" sx={font}>Unlock the full potential of your business with Clubr 360, a comprehensive product suite designed to digitize and streamline your operations across all channels. With integrated mobile apps at your fingertips, you have the power to manage and optimize your entire business with ease. Take control of your operations and be omnipresent with Clubr 360</Typography>
                </Grid>  
                <Grid item xs={8} sm={8} md={5} lg={5} xl={5}
                  className="mobileMode"
                >
                  <Image
                    src={SectionThreeImage}
                    alt="section3"
                    // width="100"
                    // height="100"
                    layout="responsive"
                    
                  />
                </Grid>
              </Grid>
            </Typography>
          </Box>

          <Box sx={{...section4, background:'#1F1E1E'}} className="desktopMode">
            <Container component="div">
              <Typography variant="h3" sx={font}>
                   Our Stats 
                  </Typography>
              <Grid container spacing={5} alignItems="center">
                {boxType == "1" ? (
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Box className="boxActive" onClick={changeBoxType("1")}>
                      <Typography variant="h4" sx={font}>
                        More Conversions
                      </Typography>
                      <Grid container spacing={0}>
                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                          <Typography variant="h2" sx={font}>
                            2x
                          </Typography>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                          <Typography variant="h5" sx={font}>Clubr 360 platform increases accessibility, revolutionizes your booking process and helps you unleash your business's full potential.</Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <Box className="box" onClick={changeBoxType("1")}>
                      <Typography variant="h4" sx={font}>
                        More Conversions
                      </Typography>
                      <Typography variant="h2" sx={font}>
                        2x
                      </Typography>
                    </Box>
                  </Grid>
                )}
                {boxType == "2" ? (
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Box className="boxActive" onClick={changeBoxType("2")}>
                      <Typography variant="h4" sx={font}>
                        Generic Calls
                      </Typography>
                      <Grid container spacing={0}>
                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                          <Typography variant="h2" sx={font}>
                            60%
                          </Typography>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                          <Typography variant="h5" sx={font}>Clubr enhances accessibility and streamlines customer support with our AI-powered ClubrBot, reducing the number of incoming calls and allowing managers to prioritize more productive aspects of the guest experience.</Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <Box className="box" onClick={changeBoxType("2")}>
                      <Typography variant="h4" sx={font}>
                        Generic Calls
                      </Typography>
                      <Typography variant="h2" sx={font}>
                        60%
                      </Typography>
                    </Box>
                  </Grid>
                )}
                {boxType == "3" ? (
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Box className="boxActive" onClick={changeBoxType("3")}>
                      <Typography variant="h4" sx={font}>
                        Data Retention
                      </Typography>
                      <Grid container spacing={0}>
                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                          <Typography variant="h2" sx={font}>
                            4x
                          </Typography>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                          <Typography variant="h5" sx={font}>Our omnichannel platform empowers venues and organizers to seamlessly capture data and visualize it in ways that were previously unimaginable.</Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <Box className="box" onClick={changeBoxType("3")}>
                      <Typography variant="h4" sx={font}>
                        Data Retention
                      </Typography>
                      <Typography variant="h2" sx={font}>
                        4x
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Container>
          </Box>
          <Box sx={section4} className="mobileMode">
            <Container component="div" sx={{ pb: 8 }}>
              <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={25}
                navigation={true}
                autoplay={true}
                loop={false}
                slidesPerView={1.15}
              >
                <SwiperSlide>
                  <Box className="boxActive" onClick={changeBoxType("1")}>
                    <Typography variant="h4" sx={font}>
                      More Conversions
                    </Typography>
                    <Grid container spacing={0}>
                      <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                        <Typography variant="h2" sx={font}>
                          2x
                        </Typography>
                      </Grid>
                      <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                        <Typography variant="h5" sx={font}>Clubr 360 platform increases accessibility, revolutionizes your booking process and helps you unleash your business's full potential.</Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </SwiperSlide>
                <SwiperSlide>
                  <Box className="boxActive" onClick={changeBoxType("2")}>
                    <Typography variant="h4" sx={font}>
                      Generic Calls
                    </Typography>
                    <Grid container spacing={0}>
                      <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                        <Typography variant="h2" sx={font}>
                          60%
                        </Typography>
                      </Grid>
                      <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                        <Typography variant="h5" sx={font}>Clubr enhances accessibility and streamlines customer support with our AI-powered ClubrBot, reducing the number of incoming calls and allowing managers to prioritize more productive aspects of the guest experience</Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </SwiperSlide>
                <SwiperSlide>
                  <Box className="boxActive" onClick={changeBoxType("3")}>
                    <Typography variant="h4" sx={font}>
                      Data Retention
                    </Typography>
                    <Grid container spacing={0}>
                      <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                        <Typography variant="h2" sx={font}>
                          4x
                        </Typography>
                      </Grid>
                      <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                        <Typography variant="h5" sx={font}>Our omnichannel platform empowers venues and organizers to seamlessly capture data and visualize it in ways that were previously unimaginable.</Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </SwiperSlide>
              </Swiper>
            </Container>
          </Box>

          <Box sx={{ ...section5, background: '#121212' }}>
            <Container component="div">
              <Grid container spacing={5} alignItems="center">
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={5}
                  lg={5}
                  xl={5}
                  className="mobileMode"
                >
                  <Typography variant="h2" sx={font}>ClubrBot- Free AI Assistant</Typography>
                  <Typography variant="h2" sx={font}>Powered by <Typography variant="span" sx={{color:darkTheme.palette.primary.main}}>ChatGPT</Typography></Typography>
                  <Typography variant="h6" sx={font}>We provide free automation for all your existing communication channels with the powerful ClubrBot. It efficiently handles queries related to ordering, support, ticketing, and table reservations for your venue.</Typography>
                  <Typography variant="h6" sx={font}>Additionally, our AI assistant sends automated notifications to customers who have added events to their cart but have not completed the checkout process.</Typography> 
                  <Stack sx={{mt:4}} flexDirection="row" display="flex">
                    <Typography component="div" sx={{mr:2}}>
                      <Image src={FaceBookIcon} width="30" height="35" alt="" layout="fixed" />
                      </Typography>
                    <Typography component="div" sx={{mr:2}}>
                      <Image src={InstagramIcon} width="35" height="35" alt="" layout="fixed" />
                      </Typography>
                    <Typography component="div" sx={{mr:2}}>
                      <Image src={WhatsAppIcon} width="35" height="35" alt="" layout="fixed" />
                      </Typography>
                  </Stack>
                </Grid>
                {/* <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>&nbsp;</Grid> */}
                <Grid item xs={8} sm={8} md={4} lg={4} xl={4}>
                  <Image
                    src={SectionFiveImage}
                    alt="section3"                    
                    layout="responsive"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>&nbsp;</Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="desktopMode"
                >
                  <Typography variant="h2" sx={font}>ClubrBot - Free AI Assistant</Typography>
                  <Typography variant="h2" sx={font}>Powered by <Typography variant="span" sx={{color:darkTheme.palette.primary.main}}>ChatGPT</Typography></Typography>
                  <Typography variant="h6" sx={font}>We provide free automation for all your existing communication channels with the powerful ClubrBot. It efficiently handles queries related to ordering, support, ticketing, and table reservations for your venue.</Typography>
                  <Typography variant="h6" sx={font}>Additionally, our AI assistant sends automated notifications to customers who have added events to their cart but have not completed the checkout process.</Typography>  
                   <Stack sx={{mt:4}} flexDirection="row" display="flex">
                    <Typography component="div" sx={{mr:2}}>
                      <Image src={FaceBookIcon} width="30" height="35" alt="" layout="fixed" />
                      </Typography>
                    <Typography component="div" sx={{mr:2}}>
                      <Image src={InstagramIcon} width="35" height="35" alt="" layout="fixed" />
                      </Typography>
                    <Typography component="div" sx={{mr:2}}>
                      <Image src={WhatsAppIcon} width="35" height="35" alt="" layout="fixed" />
                      </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Container>
          </Box>

          <Box sx={{ ...section5 }}>
            <Container component="div">
              <Grid container spacing={5} alignItems="center">              
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}                  
                >
                  <Typography variant="h2" sx={font}>Access 100s of </Typography>
                  <Typography variant="h2" sx={font}>Influencers & Promoters </Typography>
                  <Typography variant="h2" sx={font}>to Promote Your Event</Typography>
                  <Typography variant="h6" sx={font}>Clubr Tribe brings together all nightlife enthusiasts, including influencers and promoters, in one place and facilitates connections within the nightlife ecosystem. Venues can now easily connect with them, track analytics, and pay only upon successful transactions.</Typography>                  
                </Grid>
                {/* <Grid
                  item
                  xs={12}
                  sm={12}
                  md={1}
                  lg={1}
                  xl={1}                  
                >&nbsp;</Grid> */}
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Image
                    src={SectionWhatFreeImage}
                    alt="section3"
                    // width="100"
                    // height="100"
                    layout="responsive"
                  />
                </Grid> 
                  {/* <Grid
                    item
                    xs={12}
                    sm={12}
                    md={1}
                    lg={1}
                    xl={1}                  
                  >&nbsp;</Grid>          */}
              </Grid>
            </Container>
          </Box>

          <Box sx={section6}>
            <Container component="div" maxWidth="md">
              <Grid container spacing={5} alignItems="center">                
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}                  
                >
                  <Typography variant="h2" sx={font}>All you need when you need from Start to Finish of your event, All in one easy to use Tool!</Typography>                  
                </Grid>
                
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>&nbsp;</Grid>
                <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Grid container sx={{mb:5}}>
                    <Grid item xs="1" >
                      <Image src={SectionSixOneImage} width="20" height="20" alt="..." />
                    </Grid>                  
                    <Grid item xs="11">
                      <Typography variant="h5">Ticketing, Reservations, Bottle Service & Sell Tables.</Typography>
                      {/* <Typography variant="h6">Your website and apps are scalable and are capable of handling all crucial aspects of your venue from the clubr backstage app.</Typography> */}
                    </Grid>
                  </Grid>
                  <Grid container spacing="3" sx={{mb:5}}>
                    <Grid item xs="1">
                      <Image src={SectionSixTwoImage} width="20" height="20" alt="..." />
                    </Grid>
                    <Grid item xs="11">
                      <Typography variant="h5">Access Control</Typography>
                      {/* <Typography variant="h6">Our smart set of tools enables you to authenticate every ticket and ensure guest entry in under 30 seconds. With features like group check-ins and self-serve kiosks, we streamline queues and create transparency, enhancing the overall guest experience.</Typography> */}
                    </Grid>
                  </Grid>
                  <Grid container spacing="3" sx={{mb:5}}>
                    <Grid item xs="1">
                      <Image src={SectionSixThreeImage} width="20" height="20" alt="..." />
                    </Grid>
                    <Grid item xs="11">
                      <Typography variant="h5">Real-Time Reporting</Typography>
                      {/* <Typography variant="h6">Stay updated with real-time sales reports, payment methods breakdown, ticket-wise insights, and check-in statistics, empowering you to make informed decisions and stay on top of your operations.</Typography> */}
                    </Grid>
                  </Grid>
                  <Grid container spacing="3" sx={{mb:5}}>
                    <Grid item xs="1">
                      <Image src={SectionSixFourImage} width="20" height="20" alt="..." />
                    </Grid>
                    <Grid item xs="11">
                      <Typography variant="h5">Digital Marketing Support</Typography>
                      {/* <Typography variant="h6">We provide you with the power of customer segmentation, enabling you to target specific customer segments with precision. Our platform also offers extensive digital marketing support, allowing you to launch comprehensive 360-degree campaigns and engage with your customers through various channels.</Typography> */}
                    </Grid>
                  </Grid>
                </Grid>                
              </Grid>
            </Container>
          </Box>

          <Box sx={section7} className="desktopMode">
            <Container component="div">
              <Typography variant="h2" sx={font}>
                More reasons to Subscribe to Clubr Backstage
              </Typography>
              <Grid container spacing={5} alignItems="flex-start">
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  lg={3}
                  xl={3}
                  sx={{ mt: 5 }}
                >
                  <Typography component="div">
                    <Image
                      src={ReasonOneImage}
                      alt="reason1"
                      width="40"
                      height="40"
                      layout="fixed"
                    />
                    <Typography variant="h4" sx={font}>
                      Guestlist
                    </Typography>
                    <Typography variant="h6" sx={font}>Create individual profiles and set guest list limits for all stakeholders, ensuring organized and efficient guest management.</Typography>
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  lg={3}
                  xl={3}
                  sx={{ mt: 5 }}
                >
                  <Typography component="div">
                    <Image
                      src={ReasonTwoImage}
                      alt="reason1"
                      width="40"
                      height="40"
                      layout="fixed"
                    />
                    <Typography variant="h4" sx={font}>
                      Sell Merchandise
                    </Typography>
                    <Typography variant="h6" sx={font}>Elevate your brand identity and unlock additional sources of revenue through effective merchandising.</Typography>
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  lg={3}
                  xl={3}
                  sx={{ mt: 5 }}
                >
                  <Typography component="div">
                    <Image
                      src={ReasonThreeImage}
                      alt="reason1"
                      width="40"
                      height="40"
                      layout="fixed"
                    />
                    <Typography variant="h4" sx={font}>
                      Offline Sales
                    </Typography>
                    <Typography variant="h6" sx={font}>Effortlessly manage offline sales channels for every event with automated accounting, simplifying your processes.</Typography>
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  lg={3}
                  xl={3}
                  sx={{ mt: 5 }}
                >
                  <Typography component="div">
                    <Image
                      src={ReasonFourImage}
                      alt="reason1"
                      width="40"
                      height="40"
                      layout="fixed"
                    />
                    <Typography variant="h4" sx={font}>
                      User Management
                    </Typography>
                    <Typography variant="h6" sx={font}>Empower your team with user roles and access controls in the backstage app, allowing you to customize information accessibility based on staff roles and responsibilities.</Typography>
                  </Typography>
                </Grid>
              </Grid>
            </Container>
          </Box>
          <Box sx={section7} className="mobileMode">
            <Container component="div">
              <Typography variant="h2" sx={font}>
                More reasons to Subscribe to Clubr Backstage
              </Typography>
              <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={25}
                navigation={true}
                autoplay={true}
                loop={false}
                slidesPerView={1.15}
              >
                <SwiperSlide>
                  <Typography component="div">
                    <Image
                      src={ReasonOneImage}
                      alt="reason1"
                      width="40"
                      height="40"
                      layout="fixed"
                    />
                    <Typography variant="h4" sx={font}>
                      Guestlist
                    </Typography>
                    <Typography variant="h6" sx={font}>Create individual profiles and set guest list limits for all stakeholders, ensuring organized and efficient guest management.</Typography>
                  </Typography>
                </SwiperSlide>
                <SwiperSlide>
                  <Typography component="div">
                    <Image
                      src={ReasonTwoImage}
                      alt="reason1"
                      width="40"
                      height="40"
                      layout="fixed"
                    />
                    <Typography variant="h4" sx={font}>
                      Sell Merchandise
                    </Typography>
                    <Typography variant="h6" sx={font}>Elevate your brand identity and unlock additional sources of revenue through effective merchandising.</Typography>
                  </Typography>
                </SwiperSlide>
                <SwiperSlide>
                  <Typography component="div">
                    <Image
                      src={ReasonThreeImage}
                      alt="reason1"
                      width="40"
                      height="40"
                      layout="fixed"
                    />
                    <Typography variant="h4" sx={font}>
                      Offline Sales
                    </Typography>
                    <Typography variant="h6" sx={font}>Effortlessly manage offline sales channels for every event with automated accounting, simplifying your processes.</Typography>
                  </Typography>
                </SwiperSlide>
                <SwiperSlide>
                  <Typography component="div">
                    <Image
                      src={ReasonFourImage}
                      alt="reason1"
                      width="40"
                      height="40"
                      layout="fixed"
                    />
                    <Typography variant="h4" sx={font}>
                      User Management
                    </Typography>
                    <Typography variant="h6" sx={font}>Empower your team with user roles and access controls in the backstage app, allowing you to customize information accessibility based on staff roles and responsibilities.</Typography>
                  </Typography>
                </SwiperSlide>
              </Swiper>
            </Container>
          </Box>

          <Box sx={section8}>
            <Container component="div">
              <Box
                sx={{
                  background: "#0c0c0c",
                  px: { md: 10, sm: 5, xs: 5 },
                  py: { md: 5, sm: 2, xs: 2 },
                  borderRadius: 4,
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={2.5} sm={2.5} md={2.5} lg={2.5} xl={2.5}>
                    <Image
                      src={SectionEightImage}
                      alt="section8"
                      // width="100"
                      // height="100"
                      layout="responsive"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={9}
                    sm={9}
                    md={9}
                    lg={9}
                    xl={9}
                    alignSelf="center"
                  >
                    <Typography variant="h2" sx={font}>
                      Clubr Support has your back.
                    </Typography>
                    <Typography variant="h6" className="desktopMode" sx={font}>
                      Our support is always accessible on Whatsapp also and
                      ready to help you with your queries.
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Container>
          </Box>

          <Box sx={{ ...section11, background: '#000', py: 10 }}>
            <Container component="div" maxWidth="lg" sx={{ mb: 5 }}>
              <Stack display="flex" sx={{
                flexDirection: { md: "row", sm: "column", xs: "column" },
                justifyContent: { md: "space-between", sm: "center", xs: "center" }
              }}
              >
                <Typography component="div">
                  <Typography variant="h2" sx={{mb:`0 !important`}}>Experience Our</Typography>
                  <Typography variant="h2">Whitelabel Apps</Typography>
                </Typography>
                <Typography component="div" className="desktopMode">
                  <Image src={Section10Arrow} alt="..." width="200" height="100" />
                </Typography>
                <Typography component="div" sx={{ mt: { md: 10, sm: 1, xs: 1 }  }}>
                  <Grid container spacing={5}>
                    <Grid item xs={6}>
                      <a href="https://demo1.clubr.co.in" style={{ ...buttonStyle, ...font, padding: `10px 40px` }} className="animate-btn" target="_blank" rel='noreferrer'>Demo1</a>
                    </Grid>
                    <Grid item xs={6}>
                      <a href="https://demo2.clubr.co.in" style={{ ...buttonStyle, ...font, padding: `10px 40px` }} target="_blank" rel='noreferrer'>Demo2</a>
                    </Grid>
                  </Grid>
                  <Grid container spacing={5} sx={{mt:2}}>
                    <Grid item xs={6}>
                      <a href="https://demo3.clubr.co.in" style={{ ...buttonStyle, ...font, padding: `10px 40px` }} target="_blank" rel='noreferrer'>Demo3</a>
                    </Grid>
                    <Grid item xs={6}>
                      <a href="https://demo4.clubr.co.in" style={{ ...buttonStyle, ...font, padding: `10px 40px` }} target="_blank" rel='noreferrer'>Demo4</a>
                    </Grid>
                  </Grid>                 
                </Typography>
              </Stack>
            </Container>
            <Box sx={section10}></Box>
          </Box>   

          <Box sx={{...section5, background:'#121212'}}>
            <Container component="div">
              <Grid container alignItems="center"> 
                {/* <Grid
                  item
                  xs={12}
                  sm={12}
                  md={1}
                  lg={1}
                  xl={1}                  
                >&nbsp;</Grid>   */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={5}
                  lg={5}
                  xl={5}                  
                >
                  <Typography variant="h2" sx={font}>
                    Download the apps
                  </Typography>
                  <Typography variant="h6" sx={font}>
                    Your event, your rules, transform your gate experience completely with Clubr Backstage. All your bookings in one
                  </Typography>                  
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={1}
                  lg={1}
                  xl={1}                  
                >&nbsp;</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{position:'relative'}}>
                  <Image
                    src={SectionTenImage}
                    alt="section3"
                    // width="100"
                    // height="100"
                    layout="responsive"
                  />
                  <a href='https://apps.apple.com/in/app/clubr-backstage/id1586130582' target="_blank" rel='noreferrer'>
                    <Typography component="div" sx={{
                      position: 'absolute',
                      left:0 ,
                      top: '50%',
                      width: '50%',                   
                      height: '10%',
                      cursor:'pointer',
                      ...hoverAnimation
                    }}
                    >
                    </Typography>
                  </a>
                  <a href='https://play.google.com/store/apps/details?id=com.clubr.backstage' target="_blank" rel='noreferrer'>
                    <Typography component="div" sx={{
                      position: 'absolute',
                      right:0 ,
                      top: 0,
                      width: '50%',                   
                      height: '20%',
                      cursor:'pointer'
                    }}
                    >                    
                    </Typography>
                  </a>
                </Grid> 
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={1}
                    lg={1}
                    xl={1}                  
                  >&nbsp;</Grid>         
              </Grid>
            </Container>
          </Box>

          <Box sx={section9}>
            <Container component="div" maxWidth="lg">
              <Grid container spacing={5}>                
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}                  
                >
                  <Typography variant="h2" sx={font}>
                   Frequently asked questions
                  </Typography>
                  <Typography variant="h6" sx={font}>
                   Your event, your rules, transform your gate experience completely with Clubr Backstage. All your bookings in one 
                  </Typography>
                    <Link href="/contact">
                      <a>
                        <Typography component="div" sx={{
                          p: 1,
                          border: '1px solid #BABABA', 
                          color: '#BABABA',
                          borderRadius: 3,
                          width: 120,
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mt:darkTheme.spacing(2)
                        }}>
                          <Image src={talkToImage} width="15" height="15" alt="..." /> Talk to us
                        </Typography>
                      </a>
                    </Link>
                </Grid>
                       
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography component="div">
                    <Accordion
                      sx={accordion}
                      expanded={expanded === "panel1"}
                      onChange={handleChange("panel1")}
                    >
                      <AccordionSummary
                        sx={accordionSummary}
                        expandIcon={
                          expanded === "panel1" ? (
                            <RemoveIcon sx={IconStyle} />
                          ) : (
                            <AddIcon sx={IconStyle} />
                          )
                        }
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography variant="h4" sx={font}>
                          What is Clubr Backstage?
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={accordionSummary}>
                        <Typography variant="h5" sx={font}>Clubr Backstage is a comprehensive platform that empowers venues and event organizers with a wide range of tools and features to streamline their operations, enhance guest experiences, and maximize revenue potential.</Typography>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion
                      sx={accordion}
                      expanded={expanded === "panel2"}
                      onChange={handleChange("panel2")}
                    >
                      <AccordionSummary
                        sx={accordionSummary}
                        expandIcon={
                          expanded === "panel2" ? (
                            <RemoveIcon sx={IconStyle} />
                          ) : (
                            <AddIcon sx={IconStyle} />
                          )
                        }
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                      >
                        <Typography variant="h4" sx={font}>
                          Who can subscribe to clubr backstage?
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={accordionSummary}>
                        <Typography variant="h5" sx={font}>Clubr Backstage is open for subscription to a wide range of professionals and businesses in the live entertainment industry, including venues, content creators, stand-up comedians, artists, and event organizers. Whether you're a small venue, an independent artist, or a large-scale production company, Clubr Backstage offers powerful tools and features to help you manage and enhance your live events.</Typography>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion
                      sx={accordion}
                      expanded={expanded === "panel3"}
                      onChange={handleChange("panel3")}
                    >
                      <AccordionSummary
                        sx={accordionSummary}
                        expandIcon={
                          expanded === "panel3" ? (
                            <RemoveIcon sx={IconStyle} />
                          ) : (
                            <AddIcon sx={IconStyle} />
                          )
                        }
                        aria-controls="panel3a-content"
                        id="panel3a-header"
                      >
                        <Typography variant="h4" sx={font}>
                          How can Clubr Backstage benefit my venue or events?
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={accordionSummary}>
                        <Typography variant="h5" sx={font}>Clubr Backstage offers numerous benefits, including simplified ticketing and reservations management, seamless communication with guests, real-time analytics for data-driven decisions, customer segmentation for targeted marketing, and digital marketing support to deploy comprehensive campaigns.</Typography>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion
                      sx={accordion}
                      expanded={expanded === "panel4"}
                      onChange={handleChange("panel4")}
                    >
                      <AccordionSummary
                        sx={accordionSummary}
                        expandIcon={
                          expanded === "panel4" ? (
                            <RemoveIcon sx={IconStyle} />
                          ) : (
                            <AddIcon sx={IconStyle} />
                          )
                        }
                        aria-controls="panel4a-content"
                        id="panel4a-header"
                      >
                        <Typography variant="h4" sx={font}>
                          Can I integrate Clubr Backstage with my existing website?
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={accordionSummary}>
                        <Typography variant="h5" sx={font}>Absolutely! Clubr Backstage seamlessly integrates with your existing website, enhancing it with additional functionality and capabilities. You can customize and optimize your website to provide a comprehensive and interactive experience to your audience.</Typography>
                      </AccordionDetails>
                    </Accordion>


                    {moreFaqs ? (
                        <>
                          <Accordion
                            sx={accordion}
                            expanded={expanded === "panel5"}
                            onChange={handleChange("panel5")}
                          >
                            <AccordionSummary
                              sx={accordionSummary}
                              expandIcon={
                                expanded === "panel5" ? (
                                  <RemoveIcon sx={IconStyle} />
                                ) : (
                                  <AddIcon sx={IconStyle} />
                                )
                              }
                              aria-controls="panel5a-content"
                              id="panel5a-header"
                            >
                              <Typography variant="h4" sx={font}>
                                What features and functionalities does Clubr Backstage offer?
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={accordionSummary}>
                              <Typography variant="h5" sx={font}>Clubr Backstage offers a full suite of features, including ticketing and reservations management, AI-powered chatbots for real-time customer support, guest list management, offline sales channel management, data analytics, digital marketing support, and more.</Typography>
                            </AccordionDetails>
                          </Accordion>


                          <Accordion
                            sx={accordion}
                            expanded={expanded === "panel6"}
                            onChange={handleChange("panel6")}
                          >
                            <AccordionSummary
                              sx={accordionSummary}
                              expandIcon={
                                expanded === "panel6" ? (
                                  <RemoveIcon sx={IconStyle} />
                                ) : (
                                  <AddIcon sx={IconStyle} />
                                )
                              }
                              aria-controls="panel6a-content"
                              id="panel6a-header"
                            >
                              <Typography variant="h4" sx={font}>
                                What features and functionalities does Clubr Backstage offer?
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={accordionSummary}>
                              <Typography variant="h5" sx={font}>Clubr Backstage offers a full suite of features, including ticketing and reservations management, AI-powered chatbots for real-time customer support, guest list management, offline sales channel management, data analytics, digital marketing support, and more.</Typography>
                            </AccordionDetails>
                          </Accordion>

                          <Accordion
                            sx={accordion}
                            expanded={expanded === "panel7"}
                            onChange={handleChange("panel7")}
                          >
                            <AccordionSummary
                              sx={accordionSummary}
                              expandIcon={
                                expanded === "panel7" ? (
                                  <RemoveIcon sx={IconStyle} />
                                ) : (
                                  <AddIcon sx={IconStyle} />
                                )
                              }
                              aria-controls="panel7a-content"
                              id="panel7a-header"
                            >
                              <Typography variant="h4" sx={font}>
                                What features and functionalities does Clubr Backstage offer?
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={accordionSummary}>
                              <Typography variant="h5" sx={font}>Clubr Backstage offers a full suite of features, including ticketing and reservations management, AI-powered chatbots for real-time customer support, guest list management, offline sales channel management, data analytics, digital marketing support, and more.</Typography>
                            </AccordionDetails>
                          </Accordion>

                          <Accordion
                            sx={accordion}
                            expanded={expanded === "panel8"}
                            onChange={handleChange("panel8")}
                          >
                            <AccordionSummary
                              sx={accordionSummary}
                              expandIcon={
                                expanded === "panel8" ? (
                                  <RemoveIcon sx={IconStyle} />
                                ) : (
                                  <AddIcon sx={IconStyle} />
                                )
                              }
                              aria-controls="panel8a-content"
                              id="panel8a-header"
                            >
                              <Typography variant="h4" sx={font}>
                                Can Clubr Backstage be customized to fit my specific needs??
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={accordionSummary}>
                              <Typography variant="h5" sx={font}>Yes! Clubr Backstage can be customized and tailored to fit your specific requirements. We understand that each venue and event is unique, and our platform can be adapted to meet your specific needs and preferences.</Typography>
                            </AccordionDetails>
                          </Accordion>

                          <Accordion
                            sx={accordion}
                            expanded={expanded === "panel9"}
                            onChange={handleChange("panel9")}
                          >
                            <AccordionSummary
                              sx={accordionSummary}
                              expandIcon={
                                expanded === "panel9" ? (
                                  <RemoveIcon sx={IconStyle} />
                                ) : (
                                  <AddIcon sx={IconStyle} />
                                )
                              }
                              aria-controls="panel9a-content"
                              id="panel9a-header"
                            >
                              <Typography variant="h4" sx={font}>
                                What features and functionalities does Clubr Backstage offer?Is there any technical support available for Clubr Backstage users?
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={accordionSummary}>
                              <Typography variant="h5" sx={font}>Absolutely! We provide comprehensive technical support to ensure a smooth experience for Clubr Backstage users. Our dedicated support team is available to assist you with any queries or issues that may arise.</Typography>
                            </AccordionDetails>
                          </Accordion>

                          <Accordion
                            sx={accordion}
                            expanded={expanded === "panel10"}
                            onChange={handleChange("panel10")}
                          >
                            <AccordionSummary
                              sx={accordionSummary}
                              expandIcon={
                                expanded === "panel10" ? (
                                  <RemoveIcon sx={IconStyle} />
                                ) : (
                                  <AddIcon sx={IconStyle} />
                                )
                              }
                              aria-controls="panel10a-content"
                              id="panel10a-header"
                            >
                              <Typography variant="h4" sx={font}>
                                Can I access real-time analytics and reporting through Clubr Backstage?
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={accordionSummary}>
                              <Typography variant="h5" sx={font}>Yes, Clubr Backstage provides real-time analytics and reporting capabilities. You can access valuable insights on sales, payment modes, ticket breakdowns, check-in statistics, and more, empowering you to make data-driven decisions and stay informed about your operations.</Typography>
                            </AccordionDetails>
                          </Accordion>

                          <Accordion
                            sx={accordion}
                            expanded={expanded === "panel11"}
                            onChange={handleChange("panel11")}
                          >
                            <AccordionSummary
                              sx={accordionSummary}
                              expandIcon={
                                expanded === "panel11" ? (
                                  <RemoveIcon sx={IconStyle} />
                                ) : (
                                  <AddIcon sx={IconStyle} />
                                )
                              }
                              aria-controls="panel11a-content"
                              id="panel11a-header"
                            >
                              <Typography variant="h4" sx={font}>
                                How secure is Clubr Backstage in terms of data protection and privacy? 
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={accordionSummary}>
                              <Typography variant="h5" sx={font}>At Clubr, we prioritize the security and privacy of your data. We implement robust security measures and adhere to strict data protection regulations to ensure that your information is safe and confidential.</Typography>
                            </AccordionDetails>
                          </Accordion>
                    </>
                    ) : (
                        <Typography component="p" onClick={handleMoreFaqs} sx={{
                          textAlign: 'center',
                          color: '#49c155 !important',
                          cursor: 'pointer'
                        }}>Load more !!!</Typography>
                  )}



                  </Typography>
                </Grid>
               
              </Grid>
            </Container>
          </Box>
                 
        </Typography>
      </Box>
    </Fragment>
  );
}

export default Backstage;
